import{jsxs as e,jsx as t}from"react/jsx-runtime";import o from"styled-components";const i=o.div`
	display: flex;
	align-items: center;
	border-radius: 8px;
	background: ${({theme:e})=>e.bg.secondary};
	transition: background-color 0.2s ease-in-out;
	font-size: 12px;
	color: ${({theme:e})=>e.text.text};
	font-weight: 510;
	position: relative;
`,n=o.span`
	color: ${({theme:e})=>e.text.title};
	text-align: center;
	font-family: "PP Formula";
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px;
`,r=o.div`
	position: relative;
`,l=o.div`
	cursor: pointer;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 8px;
	&:hover ${i} {
		background-color: ${({theme:e})=>e.bg.secondary};
	}

	&:active ${i} {
		background-color: ${({theme:e})=>e.bg.hover};
	}
`,a=o.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	color: ${({theme:e})=>e.text.text};

	font-size: 12px;
	font-style: normal;
	font-weight: 400;
`,s=o.span`
	color: ${({theme:e})=>e.text.title};
	font-family: "PP Formula";
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
`,c=o.div`
	position: absolute;
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-radius: 20px;
	background-color: ${({theme:e})=>e.bg.general};
	padding: 16px;
	border: 1px solid ${({theme:e})=>e.border.black10};
	box-shadow: 0 0 5px 0 rgba(9, 30, 66, 0.05), 0 4px 12px 0 rgba(9, 30, 66, 0.1);
	bottom: calc(100% + 18px);
	left: 50%;
	transform: translate(-50%);
`,d=({label:o,toggle:d,popupStyles:p={},value:x,title:g,isOpen:f,description:m,configuration:h})=>e(r,{children:[e(l,Object.assign({onClick:d},{children:[t(n,{children:o}),t(i,{children:x})]})),f&&e(c,Object.assign({style:Object.assign({},p)},{children:[e(a,{children:[t(s,{children:g}),t("span",{children:m})]}),h]}))]});export{d as default};
